module.exports = __webpack_public_path__ + "static/media/passo-3.2d3f068f.png";